module.exports = __webpack_public_path__ + "img/greyList4.f8289c83.png";